import { Link } from "react-router-dom";
import { categories } from "@/mocks/news";

export default function CategoryShortcuts() {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-apps-2-line text-primary-500" />
          分类快捷入口
        </h3>
        <Link to="/category/entertainment-news" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
          全部
        </Link>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-3 gap-2">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="flex flex-col items-center gap-2 py-3 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer group"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={c.icon} />
            </span>
            <span className="text-xs text-foreground-700 group-hover:text-primary-600 transition-colors">
              {c.name}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}